import React from "react";
import { Stack, Typography } from "@mui/material";

import ShipDateCell from "./ShipDateCell";
import EstimatedCompletedCell from "./EstimatedCompletedCell";

const HEALTH_COLORS = {
  green: "#16a34a",
  yellow: "#d97706",
  red: "#dc2626",
};

const HealthCell = ({ item }) => {
  const color = HEALTH_COLORS[item.health] || HEALTH_COLORS.green;
  const label = item.daysLate > 0 ? `${item.daysLate}d late` : "On time";
  return (
    <Stack direction="row" gap="4px" alignItems="center">
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
      <Typography variant="caption" fontSize={10} color="text.secondary">
        {label}
      </Typography>
    </Stack>
  );
};

export const items = [
  { id: "workOrder", label: "Work Order" },
  { id: "partNumber", label: "Part Number" },
  { id: "partName", label: "Part Name" },
  { id: "quantity", label: "Qty" },
  { id: "estimatedCompleted", label: "Exp. Qty" },
  { id: "revenue", label: "Revenue" },
  { id: "dueDate", label: "Due Date" },
  { id: "plannedEndDate", label: "Planned End" },
  { id: "shipDate", label: "Ship Date" },
  { id: "priority", label: "Priority" },
];

export const keys = [
  {
    variant: "blueBold",
    value: "workOrder",
    navigate: true,
    route: "works",
    id: "workOrder",
  },
  {
    variant: "blueBold",
    value: "partNumber",
    navigate: true,
    route: "parts",
    id: "partId",
  },
  {
    variant: "blueBold",
    value: "partName",
    navigate: true,
    route: "parts",
    id: "partId",
  },
  { value: "quantity", defaultValue: 0 },
  {
    value: "estimatedCompleted",
    CustomComponent: EstimatedCompletedCell,
    sx: { width: "120px", maxWidth: "120px" },
  },
  { value: "revenue", isCurrency: true },
  { value: "dueDate", isDate: true },
  { value: "plannedEndDate", isDate: true, defaultValue: "—" },
  {
    value: "shipDate",
    CustomComponent: ShipDateCell,
    sx: { width: "150px", maxWidth: "150px" },
  },
  { value: "health", CustomComponent: HealthCell },
];
